import React, { useEffect } from 'react';
import ImageRow from './Components/ImageRow';
import { ContentStyles } from './ContentText';
import ProductRowComponent from './Components/ProductRowComponent';
import TextBox from './Components/TextBox';

export const convertPropsToObject = item => {
  const props = item.properties.reduce((merged, current) => {
    var _a;
    if (
      ((_a =
        current === null || current === void 0 ? void 0 : current.value) ===
        null || _a === void 0
        ? void 0
        : _a.__typename) === 'StringValue'
    ) {
      merged[current.name] = {
        type: current.type,
        value: current.value.value,
        __typename: 'StringValue'
      };
    } else {
      merged[current.name] = { type: current.type, value: current.value };
    }
    return merged;
  }, {});
  return props;
};

const ElementHandler = ({ row, index }) => {
  const type = row.type.toUpperCase();
  index = index + 1;
  switch (type) {
    case 'IMAGE-ROW':
      return <ImageRow data={row} index={index} />;
    case 'PRODUCT-ROW':
      return <ProductRowComponent data={row} index={index} />;
    case 'TEXT-BOX':
      return <TextBox data={row} index={index} />;
    default:
      return null;
  }
};

export const ContentRender = ({ data }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://snapppt.com/widgets/widget_loader/4cccafa2-f443-412d-8258-d8c4d88d1b8b/grid.js';
    script.async = true;
    const element = document.getElementById('snappt-widget');
    if (element) element.appendChild(script);
    return () => {
      if (element) element.removeChild(script);
    };
  }, []);

  if (!data || !data.items || data.items.length === 0) return null;

  return (
    <ContentStyles className="content-render-wrapper">
      {data.items.map((row, index) => (
        <ElementHandler row={row} key={index} index={index} />
      ))}
    </ContentStyles>
  );
};
